import { apiClient } from './client';
import { Story } from '../../types';

export interface CreateStoryRequest {
  title: string;
  description: string;
  coverUrl?: string;
  status?: string;
  categories?: string[];
  gender?: string;
  ongoing?: boolean;
  publishFrequency?: number | null;
}

export interface UpdateStoryRequest extends Partial<CreateStoryRequest> {
  revertScheduledToReady?: boolean;
}

export interface GetStoriesParams {
  pageIndex?: number;
  pageSize?: number;
  name?: string;
  status?: string;
  categoryId?: string;
  /** Admin username (matches story `createdBy`) */
  createdBy?: string;
  /** Comma-separated story IDs to pin at top (max 50 on server) */
  pinnedIds?: string;
}

export interface StoriesListResponse {
  pinned: Story[];
  data: Story[];
  totalRecord: number;
}

export const storiesApi = {
  getStories: async (params?: GetStoriesParams): Promise<StoriesListResponse> => {
    return apiClient.get<StoriesListResponse>('/api/v1/admin/stories', { params });
  },

  getStoryDetail: async (id: string): Promise<{ data: Story }> => {
    return apiClient.get<{ data: Story }>(`/api/v1/admin/stories/${id}`);
  },

  createStory: async (data: CreateStoryRequest, coverFile?: File): Promise<{ data: Story }> => {
    if (coverFile) {
      const formData = new FormData();
      formData.append('data', JSON.stringify(data));
      formData.append('coverImage', coverFile);
      
      return apiClient.upload<{ data: Story }>('/api/v1/admin/stories', formData);
    } else {
      return apiClient.post<{ data: Story }>('/api/v1/admin/stories', data);
    }
  },

  updateStory: async (id: string, data: UpdateStoryRequest, coverFile?: File): Promise<{ data: Story }> => {
    if (coverFile) {
      const formData = new FormData();
      formData.append('data', JSON.stringify(data));
      formData.append('coverImage', coverFile);
      
      return apiClient.uploadPut<{ data: Story }>(`/api/v1/admin/stories/${id}`, formData);
    } else {
      return apiClient.put<{ data: Story }>(`/api/v1/admin/stories/${id}`, data);
    }
  },

  deleteStory: async (id: string): Promise<{ data: {} }> => {
    return apiClient.delete<{ data: {} }>(`/api/v1/admin/stories/${id}`);
  },

  getSchedulePreview: async (storyId: string, frequency?: number): Promise<{ data: SchedulePreview }> => {
    const params = frequency !== undefined ? { frequency } : undefined;
    return apiClient.get<{ data: SchedulePreview }>(`/api/v1/admin/stories/${storyId}/schedule-preview`, { params });
  },
};

export interface SchedulePreviewEntry {
  episodeId: string;
  chap: number;
  publishedAt: string;
  action: 'publish_now' | 'schedule';
}

export interface SchedulePreview {
  entries: SchedulePreviewEntry[];
}


